/**
 * Set a CSS variable on an element.
 */
export function setCSSVariable(
  element: HTMLElement,
  name: string,
  value: string | null,
  priority?: string,
) {
  element.style.setProperty(`--${name}`, value, priority)
}

/**
 * Set a CSS variable on the root element.
 */
export function setRootCSSVariable(
  name: string,
  value: string | null,
  priority?: string,
) {
  return setCSSVariable(document.documentElement, name, value, priority)
}
